import {UmpireComponent} from '../umpire-component';

export interface UmpireComponentHeroGeneric<T> extends UmpireComponent<T> {
  items_order: ItemOrder[];
  selections: ItemSelectionType;
}

export interface ItemOrder {
  id: string;
  index: number;
}

export enum ItemSelectionType {
  auto = 'latest',
  manual = 'manual',
  autoFeatured = 'featured',
  autoPlusManual = 'autoPlusManual',
  autoFeaturedPlusManual = 'autoFeaturedPlusManual',
  autoAll = 'latest_all',
  autoAllFeatured = 'latest_all_featured',
  autoVod = 'latest_vod',
}
